import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
    fetchExternalClientDetails,
    checkIsWBSEValid
} from "../../../redux/fui/index";
import { checkRootExisted } from "../../../redux/fui";
import {
    StyledTooltip, StyledRadioGroup,
    TopRadioWrapper,
    ConfigurationFormLabel,
} from "../FuiStyles";
import { longTextEndDate, rootExistedHint, rootWrongFormatHint } from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import { checkServiceNowTicket, checkWBSECode, checkPOCname, createMaxDate } from "./CommonFunctions";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import { Grid, FormControlLabel, Radio, DialogActions } from "@material-ui/core";
import { CommonDialog, CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { isValid } from "date-fns";
import { FlashOnRounded, FormatColorReset } from "@material-ui/icons";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
// import { appNameProjectId } from "../Constants/ProductIds";

/**
 * EventOps
 * @author Poornna Aiswarya Ganeshan
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */

const EventOps = ({
    values, // the value would be changed by user's input
    updateEOForm, //the function to update DPForm values which is from redux
    createdBy, // user's EID
    checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
    isRootExist, // the value that show whether DomainContextRoot exist or not from redux
    setIsAllValid, // the function to check whether all validations are satisfieds
    selectedEnvironment,
    minDate,
    maxDate,
    isServiceEndDateInvalid,
    getSelectedEnvironment,
    getServiceEndDate,
    getNotesValue,
    notesValidations,
    configurationType,
    classes,
    history,
    email,
    idToken,
    isExternalClientLoading,
    externalClientData,
    externalClientError,
    fetchExternalClientDetails,
    isLoading,
    formClickSubmit,
    checkIsWBSEValid,
    isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {

    // open the dialog when user choose Yes in GDPR
    const config = configurationType === "quick";

    //check whether ServiceNowTicket is valid
    const [isServiceNowTicketValid, setIsServiceNowTicketValid] = useState(true);

    // check whether WBSECode and MonthlyTicketVolume are valid
    const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
    // check whether WBSECode is equal to MD & I WBSE
    const [isWBSECodeMDIValid, setIsWBSECodeMDIValid] = useState(true);
    const [isProjectNameValid, setIsProjectNameValid] = useState(true);
    const [isDialogFlowDevToken, setIsDialogFlowDevToken] = useState(false);
    const [isDialogFlowClientToken, setIsDialogFlowClientToken] = useState(false);
    //   const [isUsersFieldValid, setUsersField] = useState(false);
    const isGDPR = values.GDPR === "yes";
    const isOpenAI = values.OpenAI === "True";
    const isDedicated = values.InstanceType === "Dedicated"
    const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";
    const isDialogFlow = values.DialogFlow === "enabled";
    const isDeployServiceNowID = values.DeployServiceNowID === "True"
    const isJiraIntegration = values.DeployJiraID === "True"
    const isEmailIntegration = values.DeployEmailID === "True"
    const isATRIntegration = values.DeployATRID === "True"
    //   const isPaymentRate = values.PaymentRate === "payasyougo";
    const [isNoteVisible, setNoteVisible] = useState(true);

    const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
    const [domainContextRoot, setDomainContextRoot] = useState("[__]");
    const [regionCode, setRegionCode] = useState("[__]");
    const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
    const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
    const [isPocvalid, setPocvalid] = useState(true);
    const [isPlanInputValid, setIsPlanInputValid] = useState(false);
    const [isChecked, setIsChecked] = useState(true);
    const handleContractAvailabilityChange = (event) => {
        const value = event.target.value;
        setIsChecked(value === "yes");
        // updateEOForm("IsContractIdAvailable", value);
        if (value === "no") {
            updateEOForm("IsContractIdAvailable", "no")
            updateEOForm("SAPContractID", "0000000000")
            updateEOForm("EndToEndUId", "")
            setSapContractCodeLength(10)
            setPocvalid(false);
        } else {
            setPocvalid(true);
            updateEOForm("SAPContractID", "")
            // updateEOForm("ClientName", "")
            updateEOForm("EndToEndUId", "")
            setSapContractCodeLength(0)
        }
    };

    useEffect(() => {
        if (config) {
            setDomainContextRoot("[__]");
            setRegionCode("[__]");
        }
    }, [config]);

    if (config) {
        //updateEOForm("ClientName", "")
        updateEOForm("EndToEndUId", "")
        updateEOForm("Company", "")
        updateEOForm("AvanadeCountry", "")
        updateEOForm("AccentureCountry", "")
        updateEOForm("ChatGPT", "aiops-deployment")
        updateEOForm("ContractAvailabilityDate", "")
    }

    if (!config) {
        if (externalClientData.length > 0) {
            updateEOForm("ClientName", externalClientData[0])
            updateEOForm("EndToEndUId", externalClientData[1])
            if (externalClientData[2] !== undefined)
                updateEOForm("Company", externalClientData[2])
            if (externalClientData[3] !== undefined)
                updateEOForm("AvanadeCountry", externalClientData[3])
            if (externalClientData[4] !== undefined)
                updateEOForm("AccentureCountry", externalClientData[4])
            if (isChecked && externalClientData[5] !== undefined)
                updateEOForm("GDPR", externalClientData[5] ? "yes" : "no")
            updateEOForm("ChatGPT", "aiops-deployment")
            updateEOForm("ContractAvailabilityDate", "")
            updateEOForm("IsContractIdAvailable", "yes")
        }
    }

    if (!config) {
        if (isDialogFlow) {
            (isDialogFlowClientToken ||
                isDialogFlowDevToken) &&
                !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isWBSECodeMDIValid && isServiceNowTicketValid && isProjectNameValid && isTeamNameSelected && isPocvalid
                ? setIsAllValid(true)
                : setIsAllValid(false);
        } else {
            !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isWBSECodeMDIValid && isServiceNowTicketValid && isProjectNameValid && isTeamNameSelected
                ? setIsAllValid(true)
                : setIsAllValid(false);
        }
    } else {
        (isServiceNowTicketValid ||
            isDialogFlowClientToken ||
            isDialogFlowDevToken) &&
            !isServiceEndDateInvalid && isWBSEValid && isWBSECodeMDIValid && isProjectNameValid && isTeamNameSelected
            ? setIsAllValid(true)
            : setIsAllValid(false);
    }

    // user can only input lower case letter and numbers in DomainContextRoot
    const handleChangeRoot = (event, fieldName) => {
        const re = /^[a-z0-9]*$/;
        const value = event.target.value;
        re.test(value) && updateEOForm(fieldName, value);
        setDomainContextRoot(value)
    };

    const handleChangeRootSuggestions = (event, value, fieldName) => {
        const re = /^[a-z0-9]*$/;
        // const value = event.target.value;
        re.test(value) && updateEOForm(fieldName, value);
        setDomainContextRoot(value)
    };

    // get user's input
    const handleChange = (event, fieldName) => {
        if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
            updateEOForm(fieldName, event);
            getServiceEndDate(event);
        } else if (fieldName === "TeamName") {
            if (event !== undefined || event !== null) {
                updateEOForm(fieldName, event);
                setIsTeamNameSelected(true);
                if (values.TeamName !== "Others") {
                    updateEOForm("TeamNameOthers", "")
                }
            } else {
                setIsTeamNameSelected(false);
            }
        }
        else {
            const { value } = event.target;
            event.preventDefault();
            updateEOForm(fieldName, value);
            if (fieldName === "WBSEcode") {
                const wbsevalue = value.toUpperCase()
                if (wbsevalue.trim() === "CBYDQ001") {
                    setIsWBSECodeMDIValid(false)
                }
                // setIsWBSECodeValid(checkWBSECode(value));
                const isWBSEFormatValid = checkWBSECode(value);
                if (isWBSEFormatValid) {
                    checkIsWBSEValid(value)
                }
            }
            if (fieldName === "Pocdetails") {
                setPocvalid(checkPOCname(value));
            }
            if (fieldName === "ProjectName") {
                if (value.length > 32 || value.length < 3) {
                    setIsProjectNameValid(false)
                } else {
                    setIsProjectNameValid(true)
                }
            }
            if (fieldName === "RITM") {
                setIsServiceNowTicketValid(checkServiceNowTicket(value, isChecked, config));
            }
            if (fieldName === "DialogFlowDevToken") {
                if (value.length > 0) {
                    setIsDialogFlowDevToken(true);
                } else {
                    setIsDialogFlowDevToken(false);
                }
            }
            if (fieldName === "DialogFlowClientToken") {
                if (value.length > 0) {
                    setIsDialogFlowClientToken(true);
                } else {
                    setIsDialogFlowClientToken(false);
                }
            }
            if (fieldName === "Environment") {
                getSelectedEnvironment(value);
            }
            if (fieldName === "InstanceType") {
                if (value == "Dedicated") {
                } else {
                    updateEOForm("CAMPortalEnvironment", "Production");
                }
            }
            if (fieldName === "TentativeServiceEndDate") {
                getServiceEndDate(value);
            }
            if (fieldName === "RequestNotes") {
                if (value.length > 0 && value.length < 247) {
                    getNotesValue({ emptyString: false, maxLength: false });
                } else if (value.length === 0) {
                    getNotesValue({ emptyString: true, maxLength: false });
                } else if (value.length > 246) {
                    getNotesValue({ emptyString: false, maxLength: true });
                }
            }
            if (fieldName === "SAPContractID") {
                let sapLength = value.length
                setSapContractCodeLength(sapLength)
                if (sapLength == 10) {
                    fetchExternalClientDetails(value)
                }
            }
            if (fieldName === "OpenAI") {
                if (event.target.checked === false) {
                    updateEOForm(fieldName, "False");
                } else {
                    updateEOForm(fieldName, "True");
                }
            }
            if (fieldName === "DeployServiceNowID") {
                if (event.target.checked === false) {
                    updateEOForm(fieldName, "False");
                } else {
                    updateEOForm(fieldName, "True");
                }
            }
            if (fieldName === "DeployJiraID") {
                if (event.target.checked === false) {
                    updateEOForm(fieldName, "False");
                } else {
                    updateEOForm(fieldName, "True");
                }
            }
            if (fieldName === "DeployEmailID") {
                if (event.target.checked === false) {
                    updateEOForm(fieldName, "False");
                } else {
                    updateEOForm(fieldName, "True");
                }
            }
            if (fieldName === "DeployATRID") {
                if (event.target.checked === false) {
                    updateEOForm(fieldName, "False");
                } else {
                    updateEOForm(fieldName, "True");
                }
            }
            if (fieldName === "GDPR" && value === "yes") {
                updateEOForm("DeploymentRegion", "");
            }
            if (fieldName === "DeploymentRegion") {
                if (value == "sydney") {
                    setRegionCode("dh")
                } else if (value == "virginia") {
                    setRegionCode("dh1")
                } else if (value == "frankfurt") {
                    setRegionCode("dh2")
                } else if (value == "singapore") {
                    setRegionCode("dh3")
                } else if (value == "tokyo") {
                    setRegionCode("dh4")
                } else if (value == "ireland") {
                    setRegionCode("dh5")
                } else if (value == "london") {
                    setRegionCode("dh6")
                } else {
                    setRegionCode("[__]")
                }
            }
        }
    };

    updateEOForm("ConfigurationType", configurationType);


    // it would check whether the root has existed from DB once user stop typing longer than 0.3s
    const debouncedValue = useDebounce(domainContextRoot, 300);
    useEffect(() => {
        debouncedValue && checkDomainAvaliable(debouncedValue);
    }, [debouncedValue]);

    //form validation
    const validateInputFields = (step) => {
        let ispass = true;
        const fieldsRequired = {
            'step0': [
                'ProjectName',
                'WBSEcode',
                'SecondaryPOC',
                'TeamName',
                'RequestNotes',
            ],

            'step1': [
                'DeploymentRegion',
                'Environment',
            ],

            'step2': [
                'AdminDistributionGroup',
                'TentativeServiceEndDate',
            ]
        }

        if (config) {
            //fieldsRequired['step0'].push('ClientNameInternal');
        } else {
            if (isChecked)
                fieldsRequired['step0'].push('SAPContractID');
            else {
                fieldsRequired['step0'].push('Pocdetails', 'ClientName', 'RITM');
            }
            fieldsRequired['step1'].push('DomainContextRoot');
        }

        for (const fieldname of fieldsRequired[step]) {
            if (fieldname === "WBSEcode" && !isWBSEValid) {
                document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "2px solid #E20000";
                ispass = false;
            } else if (values[fieldname] === "") {
                document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "2px solid #E20000";
                ispass = false;
            } else {
                document.getElementById('' + fieldname).parentElement.parentElement.querySelector('fieldset').style.border = "";
            }
        }

        if (step === 'step2' && ispass)
            formClickSubmit();
        else
            return ispass;
    }

    return (
        <>
            <GeneralForm
                isPlanInputValid={isPlanInputValid}
                FormId={4}
                validateInputFields={validateInputFields}
                ClientContractFields={

                    <div>
                        {!config ?
                            <TopRadioWrapper>
                                <ConfigurationFormLabel component="legend">
                                    Is a contract ID available?
                                </ConfigurationFormLabel>


                                <StyledRadioGroup
                                    aria-label="contract-available"
                                    name="contract-available"
                                    value={isChecked ? "yes" : "no"}
                                    onChange={handleContractAvailabilityChange}
                                    row
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio color="primary" />}
                                        label="YES"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio color="primary" />}
                                        label="NO"
                                    />
                                </StyledRadioGroup>
                            </TopRadioWrapper>
                            : ""
                        }

                        {(!isChecked && !config) &&
                            <div style={{ fontSize: "small", color: "#0041F0" }}>
                                <em>
                                    To proceed with provisioning without a Contract ID, please provide the following mandatory details
                                </em>
                                <ul>
                                    <li>WBSE Code (used for chargeback if contract is not provided)</li>
                                    <li>Opportunity ID (for deal tracking and reference)</li>
                                    <li>Expected Contract Availability Date (must be within 28 days)</li>
                                    <li>Client Point of Contact (name and email for contract follow-up)</li>
                                </ul>
                            </div>
                        }

                        < div style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={2}
                            >
                                {(!config && isChecked) ?
                                    <Grid item xs={4}>
                                        {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                                    </Grid>
                                    : (!config && !isChecked) ?
                                        <Grid item xs={4}>
                                            {FormField.Pocvalid(handleChange, values, isPocvalid)}
                                        </Grid>
                                        : <></>
                                }
                                {(!config &&
                                    isChecked &&
                                    sapContractCodeLength === 10 &&
                                    !isExternalClientLoading &&
                                    !externalClientError) &&
                                    <Grid item xs={4}>
                                        {PlatformFormField.ClientNamePlatformField(
                                            values,
                                            handleChange,
                                            externalClientData[0]
                                        )}
                                    </Grid>
                                }
                                {!config &&
                                    isChecked &&
                                    sapContractCodeLength === 10 &&
                                    !isExternalClientLoading &&
                                    !externalClientError && (
                                        <Grid item xs={4}>
                                            {PlatformFormField.EndToEndUIdPlatformField(
                                                values,
                                                handleChange,
                                                externalClientData[1]
                                            )}
                                        </Grid>
                                    )
                                }
                                {(!config && !isChecked) &&
                                    <Grid item xs={4}>
                                        <StyledTooltip
                                            title={longTextEndDate}
                                            placement="left-start"
                                            noValidate
                                        >
                                            <DateTextFieldCommonComponent
                                                tentativeServiceEndDate={values.ContractAvailabilityDate}
                                                minDate={0}
                                                maxDate={createMaxDate(27)}
                                                handleChange={handleChange}
                                                idkey="ContractAvailabilityDate"
                                                label="Contract Availability Date"
                                            />
                                        </StyledTooltip>
                                    </Grid>
                                }
                                {(!config) &&
                                    <Grid item xs={4}>
                                        {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid)}
                                    </Grid>
                                }
                                {(!config && !isChecked) &&
                                    <Grid item xs={4}>
                                        {FormField.ClientNamePlatformInternal(handleChange, values)}
                                    </Grid >}

                                <Grid item xs={4}>
                                    {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                                </Grid>
                                <Grid item xs={4}>
                                    {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSECodeMDIValid, isWBSEValid, isLoading)}
                                </Grid >
                                {config &&
                                    <Grid item xs={4}>
                                        {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid)}
                                    </Grid>
                                }
                                <Grid item xs={4}>
                                    {FormField.SecondaryContact(handleChange, values, config)}
                                </Grid>
                                <Grid item xs={4}>
                                    {FormField.TeamNamesField(handleChange, values, isTeamNameSelected)}
                                </Grid >
                                {values.TeamName === "Others" &&
                                    <Grid item xs={4}>
                                        {FormField.TeamNameOthers(handleChange, values)}
                                    </Grid >
                                }
                                {
                                    (config &&
                                        <Grid item xs={4}>
                                            {FormField.ClientNamePlatformInternal(handleChange, values)}
                                        </Grid>
                                    )
                                }
                                {/* <Grid item xs={4}>
                                {config &&
                                    FormField.ClientNamePlatformInternal(handleChange, values)}
                            </Grid > */}


                                <Grid item xs={12}>
                                    {PlatformFormField.RequestNotesPlatformField(
                                        values,
                                        handleChange,
                                        notesValidations
                                    )}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                }
                EnvironmentFields={
                    <div>
                        {/* {!config ? <p> Expected Custom URL: <span style={{ color: " #0041F0" }}>https://{regionCode}.mywizard-aiops.com/{domainContextRoot}</span></p> : ""} */}
                        <div style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={2}
                            >
                                <Grid item xs={12}>
                                    {PlatformFormField.GDPREventOpsPlatformField(
                                        values,
                                        handleChange,
                                        isGDPR,
                                        classes,
                                        config,
                                        isChecked
                                    )}
                                </Grid>
                                <Grid item xs={3}>
                                    {PlatformFormField.DeploymentRegionEventOpsPlatformField(
                                        values,
                                        handleChange,
                                        isGDPR,
                                        isDedicated,
                                        config
                                    )}
                                </Grid>
                                {!config &&
                                    <Grid item xs={6}>
                                        {PlatformFormField.DomainContextRootPlatformFieldClient(
                                            values,
                                            handleChangeRootSuggestions,
                                            // handleChangeRoot,
                                            isRootExist,
                                            rootExistedHint,
                                            rootWrongFormatHint,
                                            externalClientData,
                                            domainContextRoot,
                                            isLoading
                                        )}
                                    </Grid>}
                                <Grid item xs={3}>
                                    {PlatformFormField.EnvironmentEventOpsPlatformField(values, handleChange, config)}
                                </Grid>

                            </Grid>
                        </div>
                    </div>
                }

                ApplicationFields={
                    <div style={{ flexGrow: 1 }}>
                        <Grid
                            container
                            spacing={2}
                        >

                            <Grid item xs={6}>
                                {FormField.AdminDistributionGroupField(handleChange, values)}
                            </Grid>
                            <Grid item xs={6}>
                                <StyledTooltip
                                    title={longTextEndDate}
                                    placement="left-start"
                                    noValidate
                                >
                                    <DateTextFieldCommonComponent
                                        tentativeServiceEndDate={values.TentativeServiceEndDate}
                                        selectedEnvironment={selectedEnvironment}
                                        isServiceEndDateInvalid={isServiceEndDateInvalid}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        handleChange={handleChange}
                                    />
                                </StyledTooltip>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ paddingTop: "10px" }}>
                                    <label className="MuiFormLabel-root" >Application Integrations</label>
                                    <div style={{ display: 'flex', paddingTop: "10px" }}>
                                        {FormField.DeployServiceNowIDField(handleChange, values, isDeployServiceNowID)}

                                        {FormField.DeployJiraIDField(handleChange, values, isJiraIntegration)}

                                        {FormField.DeployEmailIDField(handleChange, values, isEmailIntegration)}

                                        {FormField.DeployATRIDField(handleChange, values, isATRIntegration)}
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                }
                LeftColumnFields={
                    <div>
                    </div>
                }
                RightColumnFields={
                    <div>
                    </div>
                }
                history={history}
            ></GeneralForm>
            {!isChecked && (
                <CommonDialogV2
                    open={isNoteVisible}
                    onClose={() => setNoteVisible(false)}
                    title={"Note"}
                    textContent={
                        <div>
                            <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
                            <ul>
                                <li>
                                    Provisioned services will be automatically stopped
                                </li>
                                <li>
                                    Cost recovery will be initiated using the provided WBSE code
                                </li>
                            </ul>
                        </div>
                    }
                    dialogActions={
                        <DialogActions>
                            <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
                        </DialogActions>
                    }
                ></CommonDialogV2>
            )}
        </>
    );
};

const MSTP = (state, ownProps) => ({
    values: state.fui.EventOpsForm,
    isRootExist: state.fui.isRootExist,
    configurationType: state.fui.configurationType,
    email: state.auth.userDetails.email,
    idToken: state.auth.idToken,
    externalClientData: state.fui.externalClientData,
    externalClientError: state.fui.externalClientError,
    isExternalClientLoading: state.fui.isExternalClientLoading,
    isLoading: state.fui.isLoading,
    isWBSEValid: state.fui.isWBSEValid,
});

export default connect(MSTP, {
    checkDomainAvaliable: checkRootExisted,
    updateEOForm: fuiRedux.updateEOForm,
    fetchExternalClientDetails,
    checkIsWBSEValid
})(withRouter(EventOps));
